import axios from "axios";
import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import Select, {createFilter} from "react-select";
import {useTable} from "react-table";
import {CSVLink} from "react-csv";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {getTerminalLocationByIDApi, getTerminalTxnHistory, getUserViewListApi} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";

function TransactionHistory(props) {
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
  const [terminalSelectData, setTerminalSelectData] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState();
  const [data, setData] = useState([]);
  const [filterValue, setFilterValue] = useState("terminalID");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isTableVisible, setIsTableVisible] = useState();
  const [sortOrderOptions, setSortOrderOptions] = useState();
  const [selectedSortOrder, setSelectedSortOrder] = useState();
  const [userOptions, setUserOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState();
    const [perPage, setPerPage] = useState(50);
    const [totalRecords, setTotalRecords] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [pending, setPending] = React.useState(true);
  const history = useHistory();
  const location = useLocation();

    //  Internally, customStyles will deep merges your customStyles with the default styling.
    const tableStyles = {
        rows: {
            style: {
                minHeight: '30px',
                fontSize: '10px',// override the row height
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: '10px',
                wordBreak: 'break-word',
            },
            draggingStyle: {},
        },
        dataTableExt: {
            style: {
                Width:'40px',
            },
        },
    };
  const columns = [
    {
      Header: "Seq No",
      accessor: "seqNo",
    },
    {
      Header: "Tran Time",
      accessor: "tranTime",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "From Acct",
      accessor: "fromAcct",
    },
    {
      Header: "Batch Id",
      accessor: "batchID",
    },
    {
      Header: "Pan",
      accessor: "pan",
    },
    {
      Header: "Req Amt",
      accessor: "reqAmt",
    },
    {
      Header: "Disp Amt",
      accessor: "dispAmt",
    },
    {
      Header: "Cash Back",
      accessor: "cashBack",
    },
    {
      Header: "surch Amt",
      accessor: "surchAmt",
    },
    {
      Header: "conv Amt",
      accessor: "convAmt",
    },
    {
      Header: "Auth Amt",
      accessor: "authAmt",
    },
    {
      Header: "Auth Code",
      accessor: "authCode",
    },
    {
      Header: "Auth Msg",
      accessor: "authMsg",
    },
    {
      Header: "ATM Balance",
      accessor: "",
    },
    {
      Header: "Rev Code",
      accessor: "revCode",
    },
    {
      Header: "Rev Reason",
      accessor: "revReason",
    },
    {
      Header: "TransFlag",
      accessor: "transFlag",
    },
  ];

    const datacolumns = [
        {
            name: 'Seq No ',
            selector: row => row.seqNo,
            sortable: true,
        },
        {
            name: 'Trans Time ',
            selector: row => row.tranTime,
            sortable: true,
        },
        {
            name: 'Type ',
            selector: row => row.type,
            sortable: true,
        },
        {
            name: 'From Account ',
            selector: row => row.fromAcct,
            sortable: true,
        },
        {
            name: 'Batch ID ',
            selector: row => row.batchID,
            sortable: true,
        },
        {
            name: 'PAN ',
            selector: row => row.pan,
            sortable: true,
        },
        {
            name: 'Request Amount ',
            selector: row => row.reqAmt,
            sortable: true,
        },
        {
            name: "Disp Amt",
            selector: row => row.dispAmt,
        },
        {
            name: "Cash Back",
            selector: row => row.cashBack,
        },
        {
            name: "surch Amt",
            selector: row => row.surchAmt,
        },
        {
            name: "conv Amt",
            selector: row => row.convAmt,
        },
        {
            name: "Auth Amt",
            selector: row => row.authAmt,
        },
        {
            name: "Auth Code",
            selector: row => row.authCode,
        },
        {
            name: "Auth Msg",
            selector: row => row.authMsg,
        },
        {
            name: "ATM Balance",
        },
        {
            name: "Rev Code",
            selector: row => row.revCode,
        },
        {
            name: "Rev Reason",
            selector: row => row.revReason,
        },
        {
            name: "TransFlag",
            selector: row => row.transFlag,
        },
    ];

  const exportPDF = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "portrait";

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Transaction history Report";
    const headers = [
      [
        "seqNo",
        "Tran Time",
        "Type",
        "From Acct"
      ],
    ];

    const pdata = data?.map((elt) => [...Object.values(elt)]);

    let content = {
      startY: 50,
      head: headers,
      body: pdata,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("report.pdf");
  };

  function Table({ columns, data }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });

    return (
      <>
        <div className="report_table_outer">
          <div className="table-responsive">
            <table {...getTableProps()} className="table table-bordered  small">
              <thead className="thead-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

  useEffect(() => {
    const getUsers = async () => {
        console.log(" GET USERS BY LIST")
        var feed = {userId: loggedUserStorage, label: loggedUserStorage, value: loggedUserStorage};
        const result = await axios.get(`${getUserViewListApi}?id=${loggedUserStorage}`);
        result?.data.unshift(feed);
        setUserOptions(result?.data);
        setSelectedUser({
            label: loggedUserStorage,
            value: loggedUserStorage,
        });

    };
    setSortOrderOptions([
      { label: "ASC", value: "ASC" },
      { label: "DESC", value: "DESC" },
    ]);
    //getLocation();
    getUsers();
    return () => {
      setData([]);
      setTerminalSelectData([]);
      setUserOptions([]);

    };
  }, [location]);

  const handleUserSelection = async (e) => {
    setSelectedUser(e);
  };
  const handleSelectionLocation = async (e) => {
    setSelectedLocation(e);
  };
  useEffect(() => {
      const terminalId = location?.search?.split("=")?.[1];
      const getLocationandTerminals = async () => {

          const selectedUserByDefault = (typeof selectedUser?.userId == "undefined") ? loggedUserStorage : selectedUser?.userId;
          console.log(" GET LOCATION BY USERID BY SELECTED USER",selectedUserByDefault)
          const result = await axios.get(`${getTerminalLocationByIDApi}?paramUserID=${selectedUserByDefault}&paramByType=LOCATION&paramSearchCriteria=`);
          setLocationOptions(result?.data);
          const resultTerminal = await axios.get(`${getTerminalLocationByIDApi}?paramUserID=${selectedUserByDefault}&paramByType=TERMINAL&paramSearchCriteria=`);
          setTerminalSelectData(resultTerminal?.data);
          /*result?.data?.map(
              (item, index) => (
                      setTerminalSelectData((old) => [
                          ...old,
                          { label: item.terminalId, value: item.terminalId },
                      ])
              )
          );*/
          if(result?.data?.[0]?.location != undefined) {
              setSelectedLocation({
                  label: result?.data?.[0]?.location,
                  value: result?.data?.[0]?.location,
              });
          }else{
              setSelectedLocation([]);
          }
          if(result?.data?.[0]?.location != undefined) {
              setSelectedTerminal({
                  label: terminalId,
                  value: terminalId,
              });
          }else{
              setSelectedTerminal([])
          }
          setSelectedSortOrder({
              label: "ASC",
              value: "ASC",
          });
      };

    getLocationandTerminals();
    return () => {
      setLocationOptions([]);
      setTerminalSelectData([]);
    };
  }, [selectedUser]);
  const handleGetReport = async () => {
      if(typeof startDate === 'undefined'){
          alert("Please provide Start Date");
          return false
      }else if(typeof endDate === 'undefined'){
          alert("Please provide End Date");
          return false
      }

    try {
        let filterResult;

        {filterResult = filterValue == "terminalID" ? selectedTerminal.value :selectedLocation.value}
      const result = await axios.get(`${getTerminalTxnHistory}?termId=${filterResult}&startDate=${startDate}&endDate=${endDate}&userID=${loggedUserStorage}&sortOrder=${selectedSortOrder.value}`);
      console.log(" get result data ",result?.data?.response);
        setTotalRecords(result?.data?.response?.length);
      setData(result?.data?.response);
      setIsTableVisible(true);
    } catch (error) {}
  };
  return (
    <div>
      <div className="row mt-3">
        <div className="col col-md-5">
          <div className="d-flex justify-content-between">
            <label>Start Date:</label>
            <div>
              <input
                type="date"
                class="form-control"
                style={{ width: "12.5vw" }}
                onChange={(e) =>
                  setStartDate(
                    moment(e.target.value).format("YYYY-MM-DD HH:mm:ss")
                  )
                }
              />
            </div>
          </div>
        </div>
        <div className="col col-md-1"></div>
        <div className="col col-md-5">
          <div className="d-flex justify-content-between">
            <label>End Date:</label>
            <div>
              <input
                type="date"
                class="form-control"
                style={{ width: "12.5vw" }}
                onChange={(e) =>
                  setEndDate(
                    moment(e.target.value).format("YYYY-MM-DD HH:mm:ss")
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="row mt-3">
        <div className="col col-md-5">
          <div className="d-flex justify-content-between align-items-center">
            <label>User ID:</label>
            <div>
              <Select
                options={userOptions}
                value={selectedUser}
                onChange={handleUserSelection}
                filterOption={createFilter({ ignoreAccents: false })}
                captureMenuScroll={false}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "12.5vw",
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="col col-md-1"></div>
        <div className="col col-md-5">
          {filterValue == "terminalID" ? (
            <div className="d-flex justify-content-between ">
              <label>Terminal ID:</label>
              <div>
                <Select
                  options={terminalSelectData}
                  value={selectedTerminal}
                  onChange={(e) => setSelectedTerminal(e)}
                  filterOption={createFilter({ ignoreAccents: false })}
                  captureMenuScroll={false}
                  classNamePrefix="custom-select"
                  components={{ Option: CustomOption, MenuList: CustomMenuList }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      flex: 1,
                      width: "12.5vw",
                    }),
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-between ">
              <label>Location:</label>
              <div>
                <Select
                  options={locationOptions}
                  value={selectedLocation}
                  onChange={handleSelectionLocation}
                  filterOption={createFilter({ ignoreAccents: false })}
                  captureMenuScroll={false}
                  classNamePrefix="custom-select"
                  components={{ Option: CustomOption, MenuList: CustomMenuList }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      flex: 1,
                      width: "12.5vw",
                    }),
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {/*  */}
      <div className="row mt-3">
        <div className="col col-md-5">
          <div className="d-flex justify-content-between align-items-center">
            <label>Sort Order:</label>
            <div>
              <Select
                options={sortOrderOptions}
                value={selectedSortOrder}
                onChange={(e) => setSelectedSortOrder(e)}
                filterOption={createFilter({ ignoreAccents: false })}
                captureMenuScroll={false}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "12.5vw",
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="col col-md-1"></div>
        <div
          className="col col-md-5"
          onChange={(e) => setFilterValue(e.target.value)}
        >
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="filter"
              value="terminalID"
              id="terminalID"
              checked={filterValue == "terminalID" ? true : false}
            />
            <label class="form-check-label" htmlFor="terminalID">
              terminalID
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="filter"
              value="location"
              id="location"
              checked={filterValue == "location" ? true : false}
            />
            <label class="form-check-label" htmlFor="location">
              location
            </label>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="row d-flex justify-content-center mt-4 align-items-center">
        <span
          class="input-group-text"
          role="button"
          onClick={() => handleGetReport()}
        >
          Get Report
        </span>
        <span class="input-group-text ml-4" role="button">
          <CSVLink
            data={data}
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            Export to Excel
          </CSVLink>
        </span>
        <span class="input-group-text ml-4" role="button" onClick={() => exportPDF()}>
          Export to Pdf
        </span>
      </div>
      {/*  */}
      <div className="mt-3">
        {/*{isTableVisible && <Table columns={columns} data={data} />}*/}
          {isTableVisible &&<DataTableExtensions
              columns={datacolumns}
              data={data}
              print={false}
              export={false}
          >

              <DataTable
                  columns={datacolumns}
                  data={data}
                  noHeader
                  pagination
                  highlightOnHover
                  pointerOnHover
                  paginationServer
                  paginationTotalRows={totalRecords}
                  paginationPerPage={perPage}
                  paginationComponentOptions={{
                      noRowsPerPage: true
                  }}
                  onChangePage={page => setCurrentPage(page)}
                  customStyles={tableStyles}
              />
          </DataTableExtensions>}
      </div>
    </div>
  );
}

export default TransactionHistory;
